import { ISSUE_STATUS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const issueStatus = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getIssueStatus = () => issueStatus(
  'get',
  `${ISSUE_STATUS}?cb=${Date.now()}`,
);

export const createIssueStatus = (issueStatusName) => issueStatus(
  'post',
  ISSUE_STATUS,
  {
    issueStatusName: issueStatusName,
  },
);

export const updateIssueStatus = (
  issueStatusId,
  issueStatusName,
  isActive,
) => issueStatus(
  'put',
  `${ISSUE_STATUS}/${issueStatusId}`,
  {
    issueStatusName: issueStatusName,
    isActive: isActive,
  },
);
